import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TabList } from './tab-list';

@Component({
  selector: 'db-router-tabset',
  templateUrl: './router-tabset.component.html',
  styleUrls: ['./router-tabset.component.scss']
})
export class RouterTabsetComponent implements OnInit {
  @Input() tabs: TabList[];
  @Output() tabChange: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  onChange(selectedTab: any) {
    if (selectedTab && !selectedTab.disabled) {
      this.tabChange.emit(selectedTab);
    }
  }

}
